import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { SectionTitle, ListItem, List } from "../../_common";

import useStyles from "./styles";

const OwnerInfo = ({ data, history }) => {
  const { oiRoot } = useStyles();

  return (
    <Grid container item xs className={oiRoot}>
      <SectionTitle title="Info y empresa" />
      <List>
        <ListItem
          title="Empresa"
          value={data.owner.company_profile}
          withLink={`/companies/${data.owner.id}`}
          image={data.owner.avatar}
        />
        <ListItem title="Ubicación de la campaña" value={data.location} />
        <ListItem
          title="Lanzamiento"
          value={moment(data.created_at).format("ll")}
        />
        <ListItem
          title="Intereses"
          value={data.interests.map((e, i) => (
            <strong
              key={e.id}
              onClick={() => history.push(`/campaigns/interest/${e.id}`)}
            >
              #{e.name}{" "}
            </strong>
          ))}
        />
      </List>
    </Grid>
  );
};

export default withRouter(OwnerInfo);
